exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#Email[data-v-1dcaf4df]{margin:10px 0 16px;text-align:center;color:#5d5d5d;word-break:keep-all}", ""]);

// exports
